import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';

function LogoIcon(props) {
    const {
        colors = [
            props.theme.palette.custom.green,
            props.theme.palette.common.white,
        ],
        theme,
        className
    } = props;

    return (
        <ButtonBase
            centerRipple
            onClick={props.onClick}
            className={className}
        >
            <svg width="23" height="34" viewBox="0 0 600 960" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_175_70)">
                    <path d="M299.992 600.579C465.681 600.579 599.984 466.13 599.984 300.298C599.984 134.465 465.681 0 299.992 0C134.303 0 0 134.449 0 300.281C0 466.114 134.319 600.563 299.992 600.563V600.579ZM299.992 144.915C385.745 144.915 455.224 214.494 455.224 300.298C455.224 386.101 385.762 455.68 299.992 455.68C214.222 455.68 144.76 386.101 144.76 300.298C144.76 214.494 214.271 144.915 299.992 144.915Z" fill="white" />
                    <path d="M516.784 658.995H513.939C483.378 658.995 456.954 679.087 447.305 708.109C426.78 769.857 368.598 814.377 299.992 814.377C231.386 814.377 173.22 769.857 152.679 708.109C143.03 679.087 116.606 658.995 86.0444 658.995H83.2C34.8444 658.995 -0.29094 706.103 14.6909 752.127C53.8505 872.372 166.772 959.276 299.976 959.276C433.18 959.276 546.117 872.372 585.261 752.127C600.242 706.103 565.107 658.995 516.752 658.995H516.784Z" fill="white" />
                </g>
                <defs>
                    <clipPath id="clip0_175_70">
                        <rect width="600" height="959.276" fill="white" />
                    </clipPath>
                </defs>
            </svg>


        </ButtonBase>
    )
}

LogoIcon.propTypes = {
    colors: PropTypes.array,
};

export default withTheme(LogoIcon);
